import PropTypes from 'prop-types';
import { useState } from 'react';
// import { isDeviceVerified } from './isDeviceVerified';
// import { parseUserAgent } from './parseUserAgents';
import { useMatrixClient } from '../../../context/MatrixContext';
import './DevicesPage.css';
import DeviceList from '../../devices/DeviceList'; // Import DeviceList

const DevicesPage = ({ onBack }) => {
  const client = useMatrixClient();
  const [currentDeviceId, setCurrentDeviceId] = useState(null);

  // useEffect(() => {
  //   const fetchDevices = async () => {
  //     try {
  //       const matrixClient = matrixService.getClient();

  //       // Determine current device
  //       const deviceId = await matrixClient.getDeviceId();
  //       setCurrentDeviceId(deviceId);

  //       // Fetch and enhance devices list
  //       const { devices } = await matrixClient.getDevices();
  //       const enhancedDevicesList = devices.map(async (device) => ({
  //         ...device,
  //         isVerified: await isDeviceVerified(matrixClient, device.device_id, device.userId),
  //         ...await fetchClientInfo(matrixClient, device),
  //         // below requires org.matrix.msc3852.last_seen_user_agent, which is an optional field
  //         ...parseUserAgent(device[UNSTABLE_MSC3852_LAST_SEEN_UA.name]),
  //       }));
  //       setDevicesList(await Promise.all(enhancedDevicesList));
  //       logger.debug(JSON.stringify(devices));
  //     } catch (error) {
  //       logger.error('Failed to fetch devices or their verification status:', error);
  //     }
  //   };

  //   fetchDevices();
  // }, []);

  return (
    <div className="devices-page-content">
      <div className="devices-header-row">
        <button className="settings-back-button" onClick={onBack}>
          Back
        </button>
        <span className="devices-header">My Devices</span>
      </div>
      <div className="devices-list">
        <DeviceList userId={client?.getUserId()} /> {/* Use DeviceList */}
      </div>
    </div>
  );
};

DevicesPage.propTypes = {
  onBack: PropTypes.func.isRequired,
};

export default DevicesPage;
